import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "../../assets/css/agent/user-tickets.scss";
import RightBar from "../../components/RightBar";
import { Link, useParams } from "react-router-dom";
import axiosInstance from "../../environment/axiosInstance";
import { ToastContainer, toast } from 'react-toastify';

function TicketDetails(props) {
    // const { id } = useParams();
    const [ticket, setTicket] = useState(null);
    const [customer, setCustomer] = useState(null);
    const [department, setDepartment] = useState(null);
    const [product, setProduct] = useState(null);
    const [comment, setComment] = useState("");

    const useQuery = () => {
        const { search } = useLocation();

        return React.useMemo(() => new URLSearchParams(search), [search]);
    }

    let searchParams = useQuery();

    const toastSuccess = (message) => {
        toast.success(message);
    }

    const toastError = (message) => {
        toast.error(message);
    }

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        axiosInstance
            .get(process.env.REACT_APP_API_URL + "/support/business_owner/ticket/" + searchParams.get("id"), {
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("user_token")
                }
            })
            .then(response => {
                console.log("ticket " , response.data.Data?.ticket);
                if (response.data.statusCode == 200) {
                    setTicket(response.data.Data?.ticket);
                    setCustomer(response.data.Data?.customer);
                    setDepartment(response.data.Data?.department);
                    setProduct(response.data.Data?.product);
                }
            });
    }

    const onStatusSelected = (e) => {
        axiosInstance
            .patch(process.env.REACT_APP_API_URL + "/support/business_owner/ticket/" + searchParams.get("id"), {
                ticket_status: e.target.value
            }, {
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem("user_token")}`
                }
            })
            .then(response => {
                if (response.data?.statusCode == 200) {
                    toastSuccess(response.data.message);
                    loadData();
                }
            });
    }

    const handleValidation = () => {
        var isValid = true;

        if (!comment) {
            toastError("Comment is required");
            isValid = false;
        }

        return isValid;
    }

    const addComment = () => {
        if (handleValidation()) {
            axiosInstance
                .patch(process.env.REACT_APP_API_URL + "/support/business_owner/ticket/comment/" + searchParams.get("id"), {
                    comment: comment
                }, {
                    headers: {
                        "Authorization": `Bearer ${localStorage.getItem("user_token")}`
                    }
                }, {
                    comment: comment
                })
                .then(response => {
                    console.log(response.data);
                    if (response.data.statusCode == 200) {
                        toastSuccess("Comment added successfully.")
                        loadData();
                    }
                });
        }
    }

    return (
        <div>
            {/* <Header />
            <UsersTabs /> */}
            <div className="user-tickets row m-0">
                {/* <div
                    className="p-0 left-col"
                    style={{
                        borderRight: "1px solid #D9D9D9"
                    }}
                >
                    <LeftBar
                        customer={ticket}
                    />
                </div> */}
                <div className="p-0 center-col">
                    <div className="tickets-content p-4">
                        <h3 className="title">{ticket?.title}</h3>
                        <hr className="title-border" />
                        <div className="w-75">
                            <h5 className="subtitle m-0">Description</h5>
                            <p className="m-0 description">{ticket?.description}</p>
                            <h5 className="subtitle mt-4">Information regarding this ticket</h5>
                            <div className="table-div">
                                <table className="table info-table m-0">
                                    <tr>
                                        <td>
                                            <span className="label-bg">Department</span>
                                        </td>
                                        <td>{department?.name}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span className="label-bg">Product</span>
                                        </td>
                                        <td>{product?.name}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span className="label-bg">Channel</span>
                                        </td>
                                        <td>{ticket?.channel}</td>
                                    </tr>
                                </table>
                            </div>
                            <div className="comment-section">
                                <h5 className="subtitle">Status</h5>
                                <select
                                    className="form-control status-dropdown"
                                    value={
                                        ticket?.ticket_status == "open" ? "" : ticket?.ticket_status
                                    }
                                    onChange={(e) => onStatusSelected(e)}
                                >
                                    <option value="">Select status</option>
                                    <option value="opened">Open</option>
                                    <option value="in progress">In progress</option>
                                    <option value="resolved">Resolved</option>
                                    <option value="closed">Closed</option>
                                </select>
                            </div>
                            <div className="comment-section">
                                <h5 className="subtitle">Comment</h5>
                                {
                                    ticket?.comment ?
                                        <p className="description">{ticket.comment}</p>
                                        :
                                        <>
                                            <input
                                                type="text"
                                                placeholder="Type your comment here..."
                                                className="form-control"
                                                onChange={(e) => setComment(e.target.value)}
                                            />
                                            <button
                                                className="add-comment-btn"
                                                onClick={addComment}>Add Comment</button>
                                        </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="p-0 right-col"
                    style={{
                        borderLeft: "1px solid #D9D9D9"
                    }}
                >
                    <RightBar />
                </div>
            </div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            {/* Same as */}
            <ToastContainer />
        </div>
    )
}

export default TicketDetails;